<template>
  <GridBase data-tech>
    <h2><TextBlock file="article/data-tech-title" class="pre-line"/></h2>
    <Wrapper>
      <TabList split="All,Data,Tech" v-model="filter.category" v-if="false"/>
      <DropSelect class="keyword" :list="keywords" v-model="filter.keyword" placeholder="Keywords" use-blank dark v-if="false"/>
      <TagList class="keyword" :tags="keywords" v-model="filter.keyword"  v-if="false"/>
    </Wrapper>
    <CardHolder>
      <ArchiveCard v-for="item in cardList" card-type="article-t" :key="item.sq" data-fill="6,3,2,2" :item="item" @click="$router.push(`/archive/tech-talk/${item.seq}`)"/>
    </CardHolder>
    <More v-if="false"/>
  </GridBase>
</template>
<script>
import _ from 'lodash';
import GridBase from '@/views/components/GridBase';
import TabList from '@/views/components/TabList';
import DropSelect from '@/views/components/DropSelect';
import Wrapper from '@/views/components/Wrapper';
import CardHolder from '@/views/components/CardHolder';
import TagList from '@/views/components/TagList';
import ArchiveCard from '@/views/components/ArchiveCard';
import More from '@/views/components/More';
import responsive from '@/utils/responsive';
import TextBlock from '@/views/components/TextBlock';
// import kr from '@/data/archive/tech-talk';
// import en from '@/data/archive/tech-talk.en';

// const techData = { kr, en };

export default {
  name: 'data-tech',
  components: { TextBlock, More, ArchiveCard, TagList, CardHolder, Wrapper, DropSelect, TabList, GridBase },
  data() {
    return {
      keywords: [
        'PTAS', 'TECH', 'WMS'
      ],
      filter: {
        category: 'All',
        keyword: ''
      },
      cardList: [],
    };
  },
  computed: {
  },
  methods: {
    tagClick(tag) {
      console.log(tag);
    },
  },
  mounted() {
    this.oax.get(`/nosso/datacenter/tech/list`, { langType: this.langType })
        .then(({ data }) => {
          _.forEach( data.data, row => {
            row.category = 'tech';
            row.type = row.thumbnailPath ? 'img' : 'text';
            row.tags = row.techKeyword ? row.techKeyword.split(',') : [];
          });
          this.cardList = data.data;
          responsive.resized();
        })
        .catch(this.handler());
  }
}
</script>

<style lang="less">
@import "~@/less/proj";
[data-tech] { .pb(100);
  h2 { .mb(20); .pt(60); .ml(20); .fs(48,64,-2); color: #fff;
    .en & { .fs(54,60,0); .semi-bold; }
  }
  .skirt { .abs; .wf; .bgc(#191919); .h(170); }
  [slider] {
    .swiper-slide { .p(0, 20);
      .cover { .wh(100%,335); .rel;
        .txt {.w(100%); .max-h(108); .fs(28,1.29); .ls(-1); .bold; color:#fff; .-box; .p(0,82,0,20); .abs; .lb(0,82); .ellipsis(3); .keep-all; }
        .noting { .bgc(@c-blue); .abs; .rb; .w(240); .p(16,20); .-box;
          s { .calibre; .cal-m; .fs(20); .lh(28); color:#fff; }
          [icon] { .abs; .rt(20,16); }
        }
      }
    }
  }
  [tab-list] { .mt(20); }
  [drop-select] { .block; .mt(20); }
  [tag-list] { .hide; }


  [card-holder] { .mt(40);

  }
}

@media (min-width: @screen-md-min) {
  [data-tech] { .pb(120);
    h2 { .mb(100); .ml(50);}
    .skirt { .h(218); }
    [slider] { .mt(40);
      .swiper-slide { .p(0, 40);
        .cover { .vw-wh(688,412,768); .cover; .bg-c; .no-repeat;
          .txt { .p(0,298,0,30); .fs(34,1.41); .ellipsis(3); .max-h(144); .lb(0,30); }
        }
      }
    }
    [tab-list] { .w(333); .mh-c;}
  }
}

@media (min-width: @screen-lg-min) {
  [data-tech] { .pb(160);
    h2 { .pt(90); .ml(25%); .pl(20); .tl; .fs(80,110,-2);
      .en & { .fs(76,80,0); }
    }
    .skirt { .vw-h(196); }
    [slider] {
      .swiper-slide {
        .cover { .vw-wh(654,392); .cover; .bg-c; .no-repeat; .mh-c;
          .txt { .vw-p(0,274,0,20); .vw-fs(34,1.41); .vw-max-h(144); .vw-lb(0,20); }
          [icon] { .abs; .rb(39,35); }
        }
      }
    }

    [drop-select] { .hide; }
    [tag-list] { .block; .mt(40); }
  }
}

@media (min-width: @screen-xxl-min) {
  [data-tech] { .pb(264);
    h2 { .pt(150); .pl(40); .fs(100,125,-2.5);
      .en & { .fs(120,125,0); }
    }
    .skirt { .h(418); }
    [slider] {
      .swiper-slide {
        .cover { .wh(935,560); .cover; .bg-c; .no-repeat; .mh-c;
          .txt { .p(0,448,0,40); .fs(48,1.41); .ls(-2); .max-h(192); .lb(0,40); }
        }
      }
    }

    [drop-select] { .hide; }
    [tag-list] { .block; .mt(40); }
    [tab-list] { .mh(0); }
  }
}



</style>
